import React from 'react';
import {
  Button,
  HStack,
  Text,
  Icon,
  Badge,
  VStack,
  useBreakpointValue,
  Skeleton,
  Tooltip,
} from '@chakra-ui/react';
import { GiWallet } from 'react-icons/gi';
import { useNavigate } from 'react-router-dom';
import { useWalletContext } from '../../context/WalletContext';
import { useAuth } from '../../hooks/useAuth';

const WalletAccessButton = ({ variant = 'default', size = 'md' }) => {
  const navigate = useNavigate();
  const { walletSummary, loading } = useWalletContext();
  const { isAuthenticated } = useAuth();
  const buttonSize = useBreakpointValue({ base: 'sm', md: size });
  
  // Don't render wallet button if user is not authenticated
  if (!isAuthenticated) {
    return null;
  }
  
  // Theme colors
  const buttonBg = 'transparent';
  const buttonHoverBg = 'secondary.900';
  
  const handleWalletClick = () => {
    navigate('/wallet');
  };

  // Compact variant for mobile/tight spaces
  if (variant === 'compact') {
    return (
      <Tooltip label={`Wallet Balance: ${walletSummary ? `$${walletSummary.available_balance.toFixed(2)}` : 'Loading...'}`}>
        <Button
          onClick={handleWalletClick}
          size={buttonSize}
          bg={buttonBg}
          _hover={{ bg: buttonHoverBg }}
          color="white"
          position="relative"
        >
          <Text fontSize="xs" fontWeight="bold" textTransform="uppercase" color="dark.900">
            wallet
          </Text>
        </Button>
      </Tooltip>
    );
  }

  // Icon-only variant
  if (variant === 'icon') {
    return (
      <Button
        onClick={handleWalletClick}
        size={buttonSize}
        variant="ghost"
        color="white"
        position="relative"
        _hover={{ bg: 'whiteAlpha.200' }}
      >
        <Icon as={GiWallet} boxSize={5} />
        {walletSummary?.pending_earnings_count > 0 && (
          <Badge
            position="absolute"
            top="0"
            right="0"
            borderRadius="full"
            bg="yellow.400"
            color="black"
            fontSize="xs"
            minW="16px"
            h="16px"
          >
            {walletSummary.pending_earnings_count}
          </Badge>
        )}
      </Button>
    );
  }

  // Default full variant with balance
  return (
    <Button
      onClick={handleWalletClick}
      size={buttonSize}
      bg={buttonBg}
      _hover={{ bg: buttonHoverBg }}
      color="white"
      px={4}
      position="relative"
    >
      <HStack spacing={3}>
        <Icon as={GiWallet} boxSize={5} color="dark.900" />

        {loading ? (
          <Skeleton height="20px" width="60px" />
        ) : (
          <VStack spacing={0} align="start">
            <Text fontSize="sm" fontWeight="bold" lineHeight={1} color="dark.900">
              ${walletSummary?.available_balance?.toFixed(2) || '0.00'}
            </Text>
          </VStack>
        )}
      </HStack>
      

    </Button>
  );
};

export default WalletAccessButton;